export default __webpack_public_path__ + "static/media/betting-icon.d4e2249c.svg";